import { FC } from "react";
import { useLocation } from "react-router-dom";
import styles from "./AuthError.module.scss";
import dog from "@assets/lottie/error_dog.json";
import { Player } from "@lottiefiles/react-lottie-player";

interface LocationState {
  errorCode?: number;
}

export interface AuthErrorProps {
  errorCode?: number | null;
}

export const AuthError: FC<AuthErrorProps> = ({ errorCode: errorCodeProp }) => {
  const location = useLocation();
  const errorCodeFromState = (location.state as LocationState)?.errorCode;
  const errorCode = errorCodeProp ?? errorCodeFromState;

  const getErrorMessage = () => {
    switch (errorCode) {
      case 401:
        return {
          title: "🔐 Ошибка авторизации",
          description:
            "Неверный хэш авторизации. Возможно, кто-то пытается получить несанкционированный доступ.",
          action:
            "Пожалуйста, перезайдите в приложение и исполльзуйте только официальное приложение Telegram.",
        };
      case 424:
        return {
          title: "⏰ Время сессии истекло",
          description:
            "Время жизни приложения подошло к концу — просто нужно перезапустить приложение.",
          action:
            "Закройте и откройте приложение заново, чтобы продолжить работу.",
        };
      case 500:
        return {
          title: "🔧 Ошибка сервера",
          description: "На сервере возникла техническая проблема.",
          action:
            "Мы уже работаем над исправлением. Попробуйте зайти через несколько минут.",
        };
      default:
        return {
          title: "🧠 Упс, Telegram не отвечает",
          description:
            "Похоже, наше приложение столкнулось с ошибкой при авторизации в Telegram.",
          action:
            "Пожалуйста, попробуйте перезайти в приложение или обновите страницу.",
        };
    }
  };

  const errorMessage = getErrorMessage();

  return (
    <main className={styles.wrapper}>
      <div className={styles.content}>
        <h1 className={styles.title}>{errorMessage.title}</h1>
        <Player autoplay loop src={dog} className={styles.img} />
        <p className={styles.text}>{errorMessage.description}</p>
        <p className={styles.text}>{errorMessage.action}</p>
        <p className={styles.text}>
          📬 Если проблема остаётся — напишите нам, а мы всё починим быстрее,
          чем вы успеете заварить чай.
        </p>
      </div>
    </main>
  );
};
